// Material Dashboard 2 PRO React — dark theme override for MuiTablePagination.
// themeDark doesn't set palette.mode: "dark", so the default pagination text
// (rows-per-page label, "1-20 of 78", select value) stays in the light-mode
// dark color and is invisible on the dark surface. Force readable text;
// prev/next IconButtons already inherit via the central iconButton fix.

import colors from "assets/theme-dark/base/colors";

const { white } = colors;

const tablePagination = {
  styleOverrides: {
    root: {
      color: white.main,
    },
    selectIcon: {
      color: white.main,
    },
  },
};

export default tablePagination;
